
<template>
  <section>
    <!-- 登录态 -->
    <el-dialog top="29vh" width="800px" :visible.sync="show"  :close-on-press-escape="false" :before-close="handClose" v-loading.fullscreen.lock="loading" >
      <div class="left_title">
        <div>
          <h3>{{countyName}}</h3>
          <!-- <h3>{{areaConfigName}}</h3> -->
          <h3>农村产权流转交易中心</h3>
        </div>
        <img :src="logoUrl" alt="">
      </div>
      <div class="login">
        <div class="tab">
          <div :class="{ active: tab == 1 }" @click="changeTab(1)">登录</div>
          <div :class="{ active: tab == 2 }" @click="changeTab(2)">注册</div>
        </div>
        <el-form ref="formData" :model="formData" :rules="rules">
          <el-form-item prop="phone">
            <div class="label">
              <img src="@/assets/icon/phone.png" />
              <el-input
                placeholder="输入手机号"
                v-model="formData.phone"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="captcha" v-if="tab == 2">
            <div class="label">
              <img src="@/assets/icon/code.png" />
              <el-input
                class="code"
                placeholder="输入验证码"
                v-model="formData.captcha"
              ></el-input>
              <div class="code-text" @click="getCountdown()">
                {{ countdown }}
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="password">
            <div class="label">
              <img src="@/assets/icon/password.png" />
              <el-input
                type="password"
                placeholder="输入密码"
                v-model="formData.password"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item prop="captcha" v-if="false && tab == 1">
            <div class="label">
              <img src="@/assets/icon/code.png" />
              <el-input
                class="code"
                placeholder="输入验证码"
                v-model="formData.captcha"
              ></el-input>
              <img @click="getValidCode()" class="code-img" :src="img.url" />
            </div>
          </el-form-item>
          <el-form-item :class="{ region: tab == 2 }">
            <el-button @click="sumbit()">{{
              tab == 1 ? '登录' : '注册'
            }}</el-button>
          </el-form-item>
        </el-form>
        <div class="password" v-if="tab == 1">
          <el-checkbox v-model="checked">记住密码</el-checkbox>
          <div style="color: #2e2e2e; cursor: pointer" @click="forgetTEvt()">
            忘记密码？
          </div>
        </div>
      </div>
    </el-dialog>
    <forgetPassword :passordShow="passordShow" @closeForget="closeForget" />
  </section>
</template>

<script>
let Base64 = require('js-base64').Base64
import { mapState } from "vuex";
import forgetPassword from './forgetPassword.vue'
import publicFun from '@/utils/publicFunction.js'
import { tableFilter } from './property-exchange-center/info-collection/tableFilter'
import { sessionStore } from '@/utils/data-management'
export default {
  components: { forgetPassword },
  props: {
    tab: { type: Number, default: 1 },
  },
  data() {
    let validPass1 = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }
      if (!publicFun.isPhone(value)) {
        return callback(new Error('请输入正确的手机号'))
      }
      callback()
    }
    return {
      // tab: 1,
      img: {},
      countdown: '获取验证码',
      formData: {
        phone: '',
        password: '',
        captcha: '',
      },
      rules: {
        // ^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&*]+$)[a-zA-Z\d!@#$%^&*]+$
        phone: [{ validator: validPass1, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      checked: false,
      passordShow: false,
      loading: false,
      areaConfigName:''
    }
  },
  computed: {
    ...mapState(['cityArea','logoUrl']),
    countyName(){
      if(this.cityArea){
        if(!this.cityArea.sonAreas){
          return this.cityArea.areaConfigName
        }else if(this.cityArea.sonAreas&&this.cityArea.sonAreas.length===1){
          return this.cityArea.sonAreas[0].areaConfigName
        }else {
          return this.cityArea.city
        }
      }
    },
    show() {
      if (this.$store.state.token == 'show') {
        this.getValidCode()
        if (this.tab == 1) {
          this.loadAccountInfo()
        }
        return true
      } else {
        return false
      }
    },
    storeArea() {
      return this.$store.state.cityArea;
    },
  },
  watch: {
    tab(newVal, oldVal) {
      if (newVal) {
        this.$emit('chooseTab', newVal * 1)
      } else {
        this.$emit('chooseTab', 1)
      }
    },
    storeArea: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.areaConfigName = newVal.areaConfigName;
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeForget(v) {
      this.passordShow = false
      this.$store.dispatch('getToken', 'show')
    },
    forgetTEvt() {
      this.$store.dispatch('getToken', '')
      // publicFun.setCookie("", "", -1);
      this.passordShow = true
    },
    // 预读取cookie中用户信息
    loadAccountInfo() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'userNameRPRT') {
            this.formData.phone = Base64.decode(arr2[1]) //保存到保存数据的地方
          } else if (arr2[0] == 'userPwdRPRT') {
            this.formData.password = Base64.decode(arr2[1])
          }
        }
        this.checked = true
      }
    },
    getValidCode() {
      this.$api.sign.getValidCode({}).then((res) => {
        if (res.code == 1000) {
          this.img = res.data
        }
      })
    },
    handClose() {
      if (this.$store.state.token == 'show') {
        this.$store.dispatch('getToken', '')
      }
    },
    changeTab(index) {
      this.$emit('chooseTab', index * 1)
      sessionStore.set('toLoginTypeRPRT', index)
      this.$nextTick(() => {
        this.formData = {
          phone: '',
          password: '',
          code: '',
        }
        this.$refs.formData.resetFields()
      })
      if (index == 2) {
        this.formData.phone = ''
        this.formData.password = ''
        this.formData.code = ''
      }
    },
    // 倒计时
    getCountdown() {
      if (!publicFun.isPhone(this.formData.phone)) {
        return this.$message.error('请输入正确的手机号')
      }
      if (this.countdown != '获取验证码') return
      let countdown = 60
      this.$api.sign
        .getCardValid({ mobile: this.formData.phone })
        .then((res) => {
          if (res.code == 1000) {
            this.$message.success('验证码已发送')
            let timer = setInterval(() => {
              if (countdown == 0) {
                this.countdown = '获取验证码'
                clearInterval(timer)
              } else {
                this.countdown = `倒计时${countdown}秒`
                countdown--
              }
            }, 1000)
          }
        })
    },
    sumbit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          let data = {
            password: this.formData.password,
            captcha: this.formData.captcha,
            system: 'rural',
            app: 'pc',
          }
          if (this.tab == 1) {
            data.captcha = '1234'
            data.account = this.formData.phone
            data.uuid = this.img.validCode
            this.loading = true
            this.$api.sign
              .getLogin(data)
              .then((res) => {
                if (res.code == 1000) {
                  sessionStore.set('zctToken', res.data)
                  this.$store.dispatch('getToken', res.data)
                  this.changeTab(1)
                  if (this.checked) {
                    let name = Base64.encode(this.formData.phone)
                    let pass = Base64.encode(this.formData.password)
                    publicFun.setCookie(name, pass, 7)
                  } else {
                    publicFun.setCookie('', '', -1)
                  }
                  // 获取个人信息
                  this.$api.user.getUserInfo({}).then((res) => {
                    if (res.code == 1000) {
                      this.$store.commit('SET_USER_INFO', res.data)
                      sessionStore.set('userInfo', res.data)
                      window.location.reload()
                    }
                  })
                } else {
                  this.getValidCode()
                }
              })
              .catch((err) => {
                this.getValidCode()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            data.mobile = this.formData.phone
            let reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,20}$/
            if (!reg.test(data.password)) {
              return this.$message.error('请设置8-20位密码，组合字母和数字')
            }
            this.$api.sign
              .getRegist(data)
              .then((res) => {
                if (res.code == 1000) {
                  this.$message.success('注册成功请登录')
                  this.changeTab(1)
                }
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  /deep/ .el-dialog {
    &__header {
      display: none;
    }
    &__body {
      height: 460px;
      padding: 0;
      background: url('~@/assets/icon/login.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  .left_title{
    >div{
      color: #fff;
      position: absolute;
      top: 90px;
      left: 65px;
      h3{
        font-size: 32px;
        margin: 10px 0;
        font-family: PingFangSC-Semibold;
      }
    }
    img{
      position: absolute;
      bottom: 105px;
      left: 65px;
      width:102px;
      height: 102px;
      margin-top: 30px;
    }
  }
  .login {
    width: 269px;
    height: 368px;
    padding: 21px 31px;
    position: absolute;
    top: 25px;
    right: 20px;
    background: #fff;
    border-radius: 3px;
    .tab {
      line-height: 26px;
      margin-bottom: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      div {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #929292;
        letter-spacing: 0.4px;
        cursor: pointer;
      }
      .active {
        font-family: PingFangSC-Semibold;
        font-size: 19px;
        color: #3a4051;
        letter-spacing: 0.48px;
        position: relative;
      }
      .active::after {
        content: '';
        width: 18px;
        height: 3px;
        position: absolute;
        bottom: -5px;
        left: 10px;
        background: #3a4051;
      }
    }
    .el-form {
      .label {
        display: flex;
        align-items: center;
        position: relative;
        img {
          width: 12px;
          height: 12px;
          position: absolute;
          left: 12px;
          z-index: 2;
        }
        /deep/ .el-input {
          .el-input__inner {
            height: 46px;
            padding-left: 36px;
          }
        }
        .code {
          width: 167px;
        }
        .code-img {
          position: static;
          width: 93px;
          height: 46px;
          margin-left: 3px;
          cursor: pointer;
        }
        .code-text {
          position: static;
          width: 92px;
          height: 44px;
          line-height: 44px;
          margin-left: 7px;
          text-align: center;
          font-family: PingFangSC-Regular;
          color: #22C686;
          border: 1px solid #22C686;
          border-radius: 2px;
          cursor: pointer;
        }
      }
      .el-button {
        width: 100%;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #ffffff;
        background-image: linear-gradient(-135deg, #22c686 0%, #148257 100%);
        border-radius: 3px;
      }
      .region {
        margin-top: 44px;
      }
    }
    .password {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #aeaeb8;
    }
  }
}
</style>
